import {useSelector} from "react-redux";
import {useMemo} from "react";

const getUser= (state: any) => state.user

const rolePermissionMap = {
  ROLE_ADMIN: {
    "home": true,
    "candidates:read": true,
    "projects:read": true,
    "customers:read": true,
    "calendar:read": true,
    "stats": true,
    "email:read": true,
    "groups:read": true,
    "users:read": true,
    "system:read": true,
  },
  ROLE_COMMERCIALE: {
    "home": true,
    "candidates:read": true,
    "projects:read": true,
    "customers:read": true,
    "calendar:read": true,
    "stats": true,
    "email:read": true,
  },
  ROLE_CUSTOMER: {
  },
  ROLE_CANDIDATE: {
  },
  ROLE_CUSTOMER_CARE: {
    "customers:read": true,
    "seller-projects:read": true,
  }
}

class UserPermissions {
  protected userPermissions: any = {};

  constructor(user: any) {
    user.role.forEach((role: string) => {
      this.userPermissions = {
        ...this.userPermissions,
        ...rolePermissionMap[role],
      }
    });
    console.log('userPermissions', this.userPermissions);
  }

  has(permissionName: string): boolean {
    return this.userPermissions[permissionName];
  }
}

export function useUserPermissions() : UserPermissions{
  const user =  useSelector(getUser)
  return useMemo(()=> {
    return new UserPermissions(user);
  },[user])

}
